import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomNotificationDTO } from '../../application/interfaces';
import { FIRESTORE_TOKEN, FirestoreProvider } from '@core';

export class CustomNotificationService {
  private readonly firestoreProvider: FirestoreProvider = inject(FIRESTORE_TOKEN);

  getData(id: string): Observable<CustomNotificationDTO> {
    return this.firestoreProvider.documentSnapshot<CustomNotificationDTO>('custom-notification', id);
  }
}
